import React from "react";
import styles from "./styles";
import { withStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import {
  Button,
  Dialog,
  DialogTitle as MuiDialogTitle,
  DialogContent,
  IconButton
} from '@material-ui/core';
import { withUserProfile } from "../../../../../../userProfile/userProfileContext";
import { compose } from "recompose";
import {
  getDataWithQueryString,
  postData,
} from "../../../../../../api/componentAPIs";
import appConstants from "../../../../../../appConstants";
import { RMAXLogger } from "../../../../../../services/LoggerService/RMAXLogger";
import { withSnackbar } from "notistack";
import Events from "../../../../../../utilities/EventEmitter";
import Tooltip from "../../../../../common/StyledToolTip";
import { Form, ProDetails } from "./components";
import ErrorContainer from "../common/Error";
const LoaderDialog = React.lazy(() =>
  import("../../../../../header/dispatchHeader/DispatchLoader")
);
import { TAIL_LOADING_ZONE, MESSAGES } from "./constants";
import { withAppConfig } from "../../../../../../appConfigContext";

const dialogStyles = (theme) => ({
  root: {
    margin: 0,
    marginBottom: 0,
    padding: 16,
  },
  closeButton: {
    position: "absolute",
    right: 8,
    top: 16,
    color: theme.iconColor,
  },
});
const DialogTitle = withStyles(dialogStyles)((props) => {
  const { children, classes, onClose, handleClose, ...other } = props;
  return (
    <div>
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        {children}
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
      </MuiDialogTitle>
    </div>
  );
});

class AddProDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inputProNumber: {
        inputValue: "",
        error: null,
      },
      loadingZone: TAIL_LOADING_ZONE,
      showProDetails: false,
      addProInProgress: false,
      isGetProDetailsInProgress: false,
      addProErrorMessage: "",
    };
    this.timer = null;
    this.container = React.createRef();
  }

  componentDidMount() {
    Events.on("proAdded", this.checkAddProEventStatus);
  }

  componentWillUnmount() {
    Events.off("proAdded", this.checkAddProEventStatus);
  }

  handleChange = (name) => (value) => {
    this.setState({
      [name]: {
        inputValue: value,
        error: this.getFieldError(name, value),
      },
    });
  };

  handleLoadingZone = (_event, loadingZone) => {
    if (!loadingZone) return;
    this.setState({ loadingZone });
  };

  submitProNumber = () => {
    const { userData } = this.props;
    const proNumberError = this.getFieldError(
      "inputProNumber",
      this.state.inputProNumber.inputValue
    );
    if (proNumberError) {
      this.updateProError(proNumberError);
      return;
    }
    this.setState({
      isGetProDetailsInProgress: true,
    });
    getDataWithQueryString(
      "GetProDetails",
      `terminalCode=${userData.userProfile.terminal.code}&proId=${this.state.inputProNumber.inputValue}`
    ).then(
      (response) => {
        if (Math.trunc(response.status / 100) === 2) {
          this.setState({
            showProDetails: true,
            shipmentData: response.data,
            isGetProDetailsInProgress: false,
          });
        } else {
          const error = response?.response?.data?.error?.message;
          this.updateProError(error);
        }
      },
      () => {
        this.updateProError("Error fetching pro details");
      }
    );
  };

  updateProError = (proError) => {
    this.setState((prevState) => ({
      inputProNumber: {
        ...prevState.inputProNumber,
        error: proError,
      },
      isGetProDetailsInProgress: false,
    }));
  };

  showNotification = (errorMsg) => {
    this.props.enqueueSnackbar(errorMsg, {
      variant: "error",
    });
  };

  getFieldError = (field, value) => {
    switch (field) {
      case "inputProNumber":
        return value ? null : "* Required";
      default:
        return null;
    }
  };

  onAddProProgressTimeOut = () => {
    this.timer = setTimeout(() => {
      this.setState({ addProInProgress: false });
    }, appConstants.ONE_MINUTE_TIME_OUT);
  };

  checkAddProEventStatus = (data) => {
    const { success, proIds } = data;
    if (success) {
      this.props.enqueueSnackbar(
        `Pro #${proIds.join(",")} added successfully`,
        {
          variant: "success",
        }
      );
      this.props.handleClose();
    } else {
      this.showNotification(`Failed to add pro #${proIds.join(",")}`);
      this.setState({
        addProInProgress: false,
        addProErrorMessage: data?.message,
      });
    }
    clearTimeout(this.timer);
  };

  addPro = () => {
    const {
      userData,
      routeData,
    } = this.props;
    const isProInAnotherManifest = Boolean(this.state.shipmentData.manifestNumber);
    let apiName="AddPro", trackEventName="Add_Pro";
    if (isProInAnotherManifest) {
      apiName = "DeleteAndAddPro";
      trackEventName = "Delete_And_AddPro";
    }
    const requestObj = {
      terminalCode: userData.userProfile.terminal.code,
      proId: this.state.inputProNumber.inputValue,
      ...(isProInAnotherManifest
        ? {
            driverIdToRemove: this.state.shipmentData.driverId ?? null,
            routeIdToRemove: this.state.shipmentData.routeId ?? null,
            driverIdToAdd: routeData.driverId,
            routeIdToAdd: routeData.routeId
          }
        : {
            driverId: routeData.driverId,
            routeId: routeData.routeId
          }),
      loadingZone: this.state.loadingZone
    };
    this.setState(
      {
        addProInProgress: true,
      },
      this.onAddProProgressTimeOut
    );
    RMAXLogger.info(trackEventName, {
      action: trackEventName,
      proId: requestObj.proId,
      driverId: requestObj.driverId ?? requestObj.driverIdToAdd,
      routeId: requestObj.routeId ?? requestObj.routeIdToAdd
    });
    postData(apiName, requestObj).then(
      (response) => {
        if (Math.trunc(response?.status/100) !== 2) {
          this.handleError({proId: requestObj.proId, statusCode: response.status});
        }
      },
      () => {
        this.handleError({proId: requestObj.proId});
      }
    );
  };

  handleError = ({proId, statusCode}) => {
    this.setState({
      addProInProgress: false,
    });
    if (statusCode === 403) {
      return;
    }
    this.showNotification(`Failed to add pro #${proId}`);  
  }

  isDisabledSubmitButton = () => {
    const { shipmentData: { isCompletedPro, manifestNumber } = {} } = this.state;
    return isCompletedPro || manifestNumber === this.props.routeData.manifestNumber;
  };

  getTooltipMessage = () => {
    if (this.state.shipmentData.isCompletedPro) {
      return MESSAGES.disabledSubmit;
    }
    return this.state.shipmentData?.manifestNumber === this.props.routeData.manifestNumber
      ? MESSAGES.duplicateProInManifest
      : '';
  };

  render() {
    const {
      classes,
      open,
      handleClose,
      routeData,
    } = this.props;
    const { shipmentData: {isCompletedPro, manifestNumber} = {} } = this.state;
    const isProInAnotherManifest = Boolean(manifestNumber);
    const submitButtonLabel =isProInAnotherManifest  ? "Remove and Add Pro": "Add pro"
    const { theme } = this.props.userData.userProfile || {};
    const proAlreadyInManifest = manifestNumber === routeData.manifestNumber;
    return (
      <>
        <Dialog
          aria-labelledby="customized-dialog-title"
          open={open}
          classes={{ paper: classes.dialog }}
          className={`${classes.dialogWrapper} ${theme}`}>
          <DialogTitle
            handleClose={handleClose}
            id="customized-dialog-title"
            className={classes.divider}>
            <span className={classes.dialogTitle}>Add Pro</span>
          </DialogTitle>
          <DialogContent className="customScroll">
            {!this.state.showProDetails && (
              <Form
                handleChange={this.handleChange}
                proData={this.state.inputProNumber}
                handleSubmit={this.submitProNumber}
                isGetProDetailsInProgress={this.state.isGetProDetailsInProgress}
                clientName={this.props.configJSON?.proValidation}
              />
            )}
            {this.state.showProDetails && (
              <>
                <ProDetails
                  shipmentData={this.state.shipmentData}
                  handleChange={this.handleLoadingZone}
                  loadingZone={this.state.loadingZone}
                  isProInAnotherManifest={isProInAnotherManifest}
                  proAlreadyInManifest={proAlreadyInManifest}
                  isCompletedPro={isCompletedPro}
                  newManifest={routeData.manifestNumber}
                />
                {this.state.addProErrorMessage && (
                  <ErrorContainer message={this.state.addProErrorMessage} label="Add Pro Error" />
                )}
              </>
            )}
          </DialogContent>
          {this.state.showProDetails && (
            <div className={classes.dialogFooter}>
              <Button
                autoFocus
                onClick={handleClose}
                color="primary"
                variant="outlined"
                className={classes.actionButton}>
                Close
              </Button>
              <Tooltip title={this.getTooltipMessage()} placement="top">
                <div>
                  <Button
                    autoFocus
                    color="primary"
                    variant="contained"
                    classes={{
                      root: classes.actionButton,
                      disabled: classes.disabledButton,
                    }}
                    onClick={this.addPro}
                    disabled={this.isDisabledSubmitButton()}>
                    {submitButtonLabel}
                  </Button>
                </div>
              </Tooltip>
            </div>
          )}
        </Dialog>
        {this.state.addProInProgress && (
          <LoaderDialog container={this.container.current} eventName="Add Pro" />
        )}
      </>
    );
  }
}

export default compose(
  withStyles(styles),
  withUserProfile,
  withSnackbar,
  withAppConfig
)(AddProDialog);
